import React, {useState} from "react";
import "../../styles/CardNuoto.css"
import {useNavigate} from "react-router-dom";

interface CardNuotoProps {
    image: string;
    title: string;
    indirizzo: string;
}

function CardNuoto({ image, title, indirizzo }: CardNuotoProps) {

    const [isHovered, setIsHovered] = useState(false);
    const navigate = useNavigate();

    const handleMouseEnter = () => {
        setIsHovered(true);
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
    };

    return (
        <div
            style={{
                position: "relative",
                margin: "15px",
                textAlign: "center",
                transition: "transform 0.3s" // Aggiunta di una transizione per un effetto più fluido
            }}
            onClick={() => navigate(`${indirizzo}`)}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <img
                src={image}
                className="img-thumbnail"
                alt="..."
                style={{
                    width: "100%",
                    maxWidth: "300px",
                    height: "300px",
                    objectFit: "cover",
                    transform: isHovered ? "scale(1.1)" : "scale(1)", // Modifica della scala al passaggio del mouse
                }}
            />
            <div
                style={{
                    maxWidth: "15em",
                    position: "absolute",
                    top: "85%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    color: isHovered ? "white" : "#447aa0",
                    fontSize: "1.2rem",
                    fontWeight: "bold",
                    width: "75%",
                    textAlign: "center",
                    cursor: "pointer",
                    backgroundColor: isHovered ? "#447aa0" : "white",
                    borderRadius: "1em",
                    zIndex: 1
                }}
            >
                {title}
            </div>
        </div>
    );
}

export default CardNuoto;
